import React from 'react';

interface ITabsContext {
    /**
     * The label of the currently active Tab.
     */
    activeTab: string;
  
    /**
     * Whether the Tabs component should stretch the full width of its container
     */
    fullWidth: boolean;
  
    /**
     * Callback to handle click event.
     */
    onClick: (label: string) => void;

    id?: string;
  }

export const TabsContext = React.createContext<ITabsContext | undefined>(undefined);